var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ci-job-name-component"},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),_c('span',{staticClass:"ci-status-text"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4bb600e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/job_name_component.vue
// module id = null
// module chunks = 